import {
  GET_PAGE_DATA,
  GET_PAGE_DATA_SUCCESS,
  GET_PAGE_DATA_ERROR,
  GET_COLLECTION_OPTIONS,
  GET_COLLECTION_OPTIONS_SUCCESS,
  GET_COLLECTION_OPTIONS_ERROR,
} from "../actions";

export const getPageData = (pageId) => ({
  type: GET_PAGE_DATA,
  payload: { pageId },
});

export const getPageDataSuccess = (pageData) => ({
  type: GET_PAGE_DATA_SUCCESS,
  payload: pageData,
});

export const getPageDataError = (message) => ({
  type: GET_PAGE_DATA_ERROR,
  payload: { message },
});

export const getCollectionOptions = (collectionId) => ({
  type: GET_COLLECTION_OPTIONS,
  payload: { collectionId },
});

export const getCollectionOptionsSuccess = (collectionOptionsData) => ({
  type: GET_COLLECTION_OPTIONS_SUCCESS,
  payload: collectionOptionsData,
});

export const getCollectionOptionsError = (message) => ({
  type: GET_COLLECTION_OPTIONS_ERROR,
  payload: { message },
});